import { API } from '../Api';

interface GetHiddenCommentsParams {
  pageSize: number;
  pageNumber: number;
}

export const getHiddenComments = (params: GetHiddenCommentsParams) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/post-service/admin/get-hidden-comments', params)
      .then((response) => resolve(response.data))
      .catch(reject);
  });
};

export const unHiddenCommentApi = (
  id: string,
  lastReportId: string | null,
  lastReportDate: string | null,
  isInvalid: number | null,
  commentType: string
) => {
  const type = parseInt(commentType || '0', 10);
  return new Promise<boolean>((resolve, reject) => {
    API.post(`/v1/post-service/comments/update-report-detail`, {
      id,
      isHiddenByReport: false,
      lastReportId,
      lastReportDate,
      isInvalid,
      commentType: type,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
